module.exports = __webpack_public_path__ + "img/cta1.c925a853.jpeg";